import { PanelType } from '../../panels/types';

export const aiAgentCenterPanelType: PanelType = {
  name: 'AI_AGENT_CENTER_PANEL',
  location: 'right'
};
